import React, { forwardRef } from "react";
import Link from "next/link";
import PropTypes from "prop-types";

const ForwardedLink = forwardRef(({ href, children, ...props }, ref) => (
  <Link href={href} legacyBehavior passHref>
    <a ref={ref} {...props}>
      {children}
    </a>
  </Link>
));

ForwardedLink.displayName = "ForwardedLink";

ForwardedLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default ForwardedLink;
